import { render } from "./ScSelectEmailWithTagsAndSearch.vue?vue&type=template&id=a77f3f2c&scoped=true"
import script from "./ScSelectEmailWithTagsAndSearch.vue?vue&type=script&lang=js"
export * from "./ScSelectEmailWithTagsAndSearch.vue?vue&type=script&lang=js"

import "./ScSelectEmailWithTagsAndSearch.vue?vue&type=style&index=0&id=a77f3f2c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a77f3f2c"]])

export default __exports__